import _isUndefined from "lodash-es/isUndefined";
import _isString from "lodash-es/isString";
import _isObject from "lodash-es/isObject";
import _isNumber from "lodash-es/isNumber";
import _isNil from "lodash-es/isNil";
import _isNaN from "lodash-es/isNaN";
import { numberFormat } from 'underscore.string';

function applyWrapper(formattedValue, value, options) {
  var wrapAll = options.wrapAll,
      wrapPositive = options.wrapPositive,
      wrapNegative = options.wrapNegative;
  var wrappedValue = formattedValue;
  var wrappers = [];

  if (wrapAll) {
    wrappers = wrappers.concat(wrapAll.split(' '));
  }

  if (wrapPositive && value >= 0) {
    wrappers = wrappers.concat(wrapPositive.split(' '));
  }

  if (wrapNegative && value < 0) {
    wrappers = wrappers.concat(wrapNegative.split(' '));
  }

  if (wrappers.length) {
    wrappedValue = "<span class=\"".concat(wrappers.join(' '), "\">").concat(wrappedValue, "</span>");
  }

  return wrappedValue;
} // TODO - see if there's a better way to implement this functionality
// assigned default value(s) to input parameters to avoid script error with undefined values.


export function truncateNumberToDecimalPlace() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var decimalPlace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var toDecimalPlace = new RegExp("(-?\\d+\\.?\\d{0,".concat(decimalPlace, "})\\d*"));
  return Number(value.toString().match(toDecimalPlace)[1]);
}
export function formatNumber(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (_isNil(value)) {
    return '';
  }

  var sourceNumber = value;
  var formattedNumber = '';

  if (_isString(sourceNumber)) {
    sourceNumber = Number(sourceNumber);
  }

  if (_isNumber(sourceNumber) && !_isNaN(sourceNumber)) {
    var decimalPlaces = _isUndefined(options.decimalPlaces) ? 2 : options.decimalPlaces;
    var orderSeparator = _isUndefined(options.orderSeparator) ? ',' : options.orderSeparator;
    formattedNumber = numberFormat(sourceNumber, decimalPlaces, '.', orderSeparator);
    formattedNumber = applyWrapper(formattedNumber, sourceNumber, options);
  }

  return formattedNumber;
}
export function formatMoney(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (_isNil(value)) {
    return '';
  }

  var money = value;
  var formattedMoney = '';

  if (_isString(money)) {
    money = Number(money.replace(/,/g, ''));
  }

  if (_isNumber(money) && !_isNaN(money)) {
    var symbol = options.symbol || '$';
    var sign = value < 0 ? '-' : '';
    formattedMoney = sign + symbol + formatNumber(truncateNumberToDecimalPlace(Math.abs(money), 2), {
      decimalPlaces: options.decimalPlaces
    });
    formattedMoney = applyWrapper(formattedMoney, money, options);
  }

  return formattedMoney;
} // TODO - refactor this function

export function formatAlertMessage(inputMessage) {
  var defaultMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var outputMessage = inputMessage || defaultMessage;

  try {
    // Extracting the message data from response.
    if (_isObject(outputMessage) && !Array.isArray(outputMessage)) {
      // Handling axios error response
      // @ts-ignore Fix this function, impossible to type
      var _outputMessage = outputMessage,
          response = _outputMessage.response;
      outputMessage = response || outputMessage;

      if (outputMessage.responseJSON) {
        outputMessage = outputMessage.responseJSON;
      } else if (outputMessage.responseText && outputMessage.responseText.length > 0) {
        outputMessage = JSON.parse(outputMessage.responseText);
      } else if (outputMessage.data && outputMessage.data.message) {
        outputMessage = outputMessage.data.message;
      } else if (outputMessage.message) {
        outputMessage = outputMessage.message;
      } else {
        outputMessage = defaultMessage;
      }
    }
  } catch (e) {
    outputMessage = defaultMessage;
  } // Parsing the message data for final output


  if (outputMessage && _isString(outputMessage)) {
    outputMessage = [outputMessage];
  } else if (outputMessage && _isObject(outputMessage) && !Array.isArray(outputMessage)) {
    // @ts-ignore Fix this function, impossible to type
    outputMessage = outputMessage.message ? [outputMessage.message] : [defaultMessage];
  } else if (outputMessage && Array.isArray(outputMessage)) {
    outputMessage = outputMessage.map(function (m) {
      return m && m.message ? m.message : m;
    });
  }

  return outputMessage;
}
export function formatPhone(value) {
  if (_isNil(value)) {
    return '';
  }

  var formattedValue = _isNumber(value) ? value.toString() : value;
  formattedValue = (formattedValue || '').replace(/\D/g, '');

  if (formattedValue.length === 10) {
    formattedValue = formattedValue.replace(/(.{3})(.{3})(.{4})/, '($1) $2-$3');
  } else if (formattedValue.length === 11 && formattedValue.charAt(0) === '1') {
    formattedValue = formattedValue.substr(1);
    formattedValue = formattedValue.substr(0, 10).replace(/(.{3})(.{3})(.{4})/, '($1) $2-$3');
  }

  return formattedValue;
} // format zip codes

export function formatZip(postalCode) {
  if (_isNil(postalCode)) {
    return undefined;
  }

  var zip;

  if (_isNumber(postalCode) || _isString(postalCode)) {
    zip = "".concat(postalCode);
  } else {
    return;
  }

  zip = zip.trim().replace(/\D+/g, '');
  var zipLength = zip.length;

  if (zipLength === 9) {
    return "".concat(zip.slice(0, 5), "-").concat(zip.slice(5, 9));
  }

  return zip;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/util/formatters.js
// module id = 554
// module chunks = 0